import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Newspaper, Mic2, Radio, FileText } from 'lucide-react';
const press = [{
  icon: Newspaper,
  type: 'Article',
  outlet: 'Healthcare Leadership Review',
  title: 'How Association Leaders Are Reshaping Physician Advocacy',
  date: 'March 2025'
}, {
  icon: Mic2,
  type: 'Interview',
  outlet: 'The Healthcare Executive Podcast',
  title: 'Building Coalitions for Lasting Healthcare Reform',
  date: 'January 2025'
}, {
  icon: Radio,
  type: 'Feature',
  outlet: 'Regional Public Radio',
  title: 'Inside the Fight for Physician Workforce Development',
  date: 'November 2024'
}, {
  icon: FileText,
  type: 'Press Mention',
  outlet: 'State Policy Journal',
  title: 'Task Force Advances Landmark Healthcare Initiative',
  date: 'September 2024'
}];
export function Media() {
  useEffect(() => {
    document.title = 'Media & Press | Michelle McOmber Healthcare Executive';
  }, []);
  return <div className="w-full bg-slate-50 min-h-screen" data-id="element-387">
      <header className="bg-navy-900 text-white py-20" data-id="element-388">
        <div className="max-w-7xl mx-auto px-6" data-id="element-389">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-390">
            <h1 className="text-4xl md:text-5xl font-serif font-bold mb-4 text-white" data-id="element-391">
              Media &amp; Press
            </h1>
            <p className="text-xl text-slate-300 max-w-2xl" data-id="element-392">
              Interviews, articles, news features, and press mentions across
              healthcare media.
            </p>
          </motion.div>
        </div>
      </header>

      <section className="py-20" data-id="element-393">
        <div className="max-w-7xl mx-auto px-6" data-id="element-394">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-395">
            {press.map((p, i) => <motion.article key={p.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.06
          }} className="bg-white rounded-xl border border-slate-100 p-8 hover:shadow-executive transition-shadow" data-id="element-396">
                <div className="flex items-center justify-between mb-4" data-id="element-397">
                  <span className="inline-flex items-center text-gold font-semibold text-sm uppercase tracking-wide" data-id="element-398">
                    <p.icon className="w-4 h-4 mr-2" data-id="element-399" />
                    {p.type}
                  </span>
                  <span className="text-slate-400 text-sm" data-id="element-400">{p.date}</span>
                </div>
                <h2 className="text-xl font-bold text-navy-900 mb-2" data-id="element-401">
                  {p.title}
                </h2>
                <p className="text-slate-500" data-id="element-402">{p.outlet}</p>
              </motion.article>)}
          </div>
        </div>
      </section>
    </div>;
}